module.exports = __webpack_public_path__ + "assets/img/phone.5945731d.png";